export default __webpack_public_path__ + "static/media/set-fan-background.323a9335.png";